require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/maps/MapCube.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/maps/MapCube.legacy.js
// module id = 664
// module chunks = 31